import React, { Component } from "react";
import { bool, func } from "prop-types";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";
import compose from "ramda/src/compose";
import { restoreCredentials } from "services/state/actions";

class PrivateRoute extends Component {
  UNSAFE_componentWillMount() {
    this.restore(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.restore(nextProps);
  }

  UNSAFE_componentWillUpdate(props) {
    this.redirect(props);
  }

  restore({ verified, restoreCredentials }) {
    !verified && restoreCredentials();
  }

  redirect = ({ verified, authenticated, history }) => {
    if (verified && !authenticated) {
      history.push("/login");
    }
  };

  render() {
    const { authenticated, ...rest } = this.props;
    return authenticated ? <Route {...rest} /> : null;
  }
}

PrivateRoute.propTypes = {
  authenticated: bool.isRequired,
  restoreCredentials: func.isRequired,
  verified: bool.isRequired,
};

function mapStateToProps({ auth: { authenticated, verified } }) {
  return { authenticated, verified };
}

const enhance = compose(
  withRouter,
  connect(mapStateToProps, { restoreCredentials })
);

export default enhance(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js